module.exports = {
	"the_guco": "We =)",
	"cases": "Cases",
	"projects": "Projects",
	"clients": "Clients",
	"contact": "Contact",
	"all": "All",
	"apps": "Apps",
	"systems": "Systems",
	"sites": "Sites",
	"ecommerce": "e-Commerce",
	"ecommerces": "e-Commerces",
	"name": "Name",
	"phone": "Phone",
	"email": "Email",
	"message": "Message",
	"address": "Address",
	"contacts": "Contacts",
	"site_system": "Site/System",
	"app": "App",
	"site": "Site",
	"system": "System",
	"messages": {
		"menu_about_text": "Get to know us better",
		"menu_cases_text": "Look up some of our jobs",
		"menu_projects_text": "This is our work",
		"menu_clients_text": "Our clients, partners and friends",
		"menu_contact_text": "Come and have a coffee"
	},
	"sections": {
		"about": {
			"first_title": "We are a design and development agency that for 10 years has been creating innovative solutions for our customers.",
			"first_location": "Company located in Sorocaba (SP, Brazil), but thanks to the web (special thanks to <a href=\"https://www.w3.org/People/Berners-Lee\" target=\"_blank\">Tim Berners-Lee</a>) we work all over the world.",
			"first_text": "We love technology (but ASP.NET, <span class=\"tash\">kidding</span>... No, seriously) and we present this to our clients in a transparent way.",
			"second_title": "We understand your business and create the best solution for it",
			"second_text": "From an app, system, website, e-commerce to a social network (maybe you’re meant to be the creator of a new facebook) with the best performance and structure (we love clean code and well written). We are always growing and we understand your business will expand too, just because of that we always develop scalable tools so you don’t face difficulties in expanding or implementing new features.",
			"third_title": "We are users too, that’s why we develop our projects thinking in better user experience (UX), competence, innovation, and tool usability (and never let you click twice if you could do the same with only one click)",
			"third_text": "We also brew the best coffee in the area, come visit us."
		},
		"cases": {
			"title": "<span>C</span><span>A</span><span>S</span><span>E</span><span>S</span>"
		},
		"projects": {
			"title": "<span>P</span><span>R</span><span>O</span><span>J</span><span>E</span><span>C</span><span>T</span><span>S</span>"
		},
		"contact": {
			"form": {
				"title": "Contact us",
				"sub": "filling out the form below"
			},
			"for_further_info": "Ready to start a project or need a quote? Great, fill out our project inquiry form and we can get started. We’re looking forward to hearing from you."
		},
		"loading": {
			"title": "<span>L</span><span>O</span><span>A</span><span>D</span><span>I</span><span>N</span><span>G</span>"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en-US.json
// module id = 65
// module chunks = 0